import {gql} from "@apollo/client";

export const GET_SUBSCRIPTION_FEATURES = gql`
    query GetSubscriptionFeatures {
        getSubscriptionFeatures {
            Id
            id: Id
            key
            name
            createdBy
            createdAt
            updatedAt
        }
    }
`;
